<template>
    <div id="app">
        <Header></Header>
        <router-view/>
        <Footer></Footer>
    </div>
</template>
<script>
    import Header from './components/Header/Header.vue';
    import Footer from './components/Footer/Footer.vue';

    export default {
        components: {
            'Header': Header,
            'Footer': Footer,
        },
    }
</script>
<style lang="scss">
    #app {
        min-height: 100%;
        display: flex;
        flex-direction: column;
    }
    section[data-width="100%"]{
      margin: 0 auto!important;
    }
    @import './assets/css/common.scss';
</style>
